module.exports = __webpack_public_path__ + "media/images/flags-black-aeff4c78.svg";